import { PublicationHistoryItem } from "../publication-history/PagedPublicationHistoryList";

export class Publishing {
  publishDate: string;
  ProjectsSubmittedENF: PublicationHistoryItem[] = [];
  ProjectsSubmittedENFSiteVisits: PublicationHistoryItem[] = [];
  ProjectsSubmittedEIR: PublicationHistoryItem[] = [];
  ProjectsSubmittedNPC: PublicationHistoryItem[] = [];
  ProjectsSubmittedSRPR: PublicationHistoryItem[] = [];
  ProjectsUnderENF: PublicationHistoryItem[] = [];
  ProjectsUnderEIR: PublicationHistoryItem[] = [];
  ProjectsUnderNPC: PublicationHistoryItem[] = [];
  ProjectsUnderSRPR: PublicationHistoryItem[] = [];
  SecretaryCertENF: PublicationHistoryItem[] = [];
  SecretaryCertEIR: PublicationHistoryItem[] = [];
  SecretaryCertNPC: PublicationHistoryItem[] = [];
  SecretaryCertROD: PublicationHistoryItem[] = [];
  SecretaryCertSRP: PublicationHistoryItem[] = [];
  SecretaryCertPBN: PublicationHistoryItem[] = [];
  SecretaryCertAO: PublicationHistoryItem[] = [];
  publicationRequestAO: PublicationHistoryItem[] = [];
  publicationPublicNotices: PublicationHistoryItem[] = [];

  constructor() {
    this.ProjectsSubmittedENF.push(new PublicationHistoryItem());
  }
}